import creator from '../elementCreator';
import globals from '../globals';
import Style from 'ol/style/Style.js';
import Stroke from 'ol/style/Stroke.js';
import Fill from 'ol/style/Fill.js';
import Text from 'ol/style/Text.js';
import Circle from 'ol/style/Circle.js';
import Icon from 'ol/style/Icon.js';
import Vector from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Draw from 'ol/interaction/Draw.js';
import Overlay from 'ol/Overlay.js';

"use strict";
var privateFns, mapInteractions, clickFns, parameters, remove;
parameters = {
	selectedColor: "black",
	interaction: undefined,
	btn: undefined,
},
mapInteractions = {
	getActiveInteractions: function () {
		var interactions = {};
		globals.map.getInteractions().forEach(function (i) {
			if (i.get("itype") === "draw") {
				interactions.measureInteraction = i;
			} else if (i.get("interactionId") === "featurehover") {
				interactions.mapHoverInteraction = i;
			} else if (i.get("featurehover") === "featureclick") {
				interactions.mapClickInteraction = i;
			}
		});
		return interactions;
	},
},
privateFns = {
	addWriterControlPanel: function(){
		var panel, textField, clearBtn, removeBtn;
		panel = creator.createDiv({
			text: "Din tekst her",
			css: "map-writer-panel",
			id: "map-writer-panel",
		});
		
		textField = creator.createInput({type: "text", id: "mapWriterField"});
		panel.appendChild(textField);
		
		clearBtn = creator.createButton({
			icon: true,
			iconClass: "fa fa-trash",
			ariaLabel: "Fjern kommentar",
			id: "fjernBtn",
			title: "Fjern kommentar",
			onclick: function(evt){
				let btn = $(evt.target);
				if(btn.prop("nodeName") === "I"){
					btn = btn.parent();
				}
				if(btn.hasClass('active')){
					btn.removeClass("active");
					btn.css('background-color', 'white');
					remove = false;
					globals.map.removeInteraction(parameters.trashInteraction);
				}else{
					btn.addClass("active");
					btn.css('background-color', '#B3F5FF');
					remove = true;
					privateFns.addPointerTrash();
				}
				
			}
		});
		clearBtn.style.float = "right";
		panel.appendChild(clearBtn);
		panel.appendChild(privateFns.createColorPanel());
		panel.appendChild(privateFns.createTextSizePanel());
		
		document.getElementById("map").appendChild(panel);
		$("#map-writer-panel").show();
	},
	createColorPanel: function(){
		var colorPanel = creator.createDiv({
		});
		var textArea = creator.createDiv({
			text: "Velg farge",
			css: "color-panel"
		});
		var colorPallet = creator.createDiv({
			css: "color-pallet",
		});
		
		var btns = ["mBlaBtn", "blaBtn", "lBlaBtn", "rodBtn", "mGronnBtn", "gronnBtn", "lGronnBtn", "sortBtn", "gulBtn", "mBeigeBtn", "beigeBtn"]
		btns.forEach(function(btn){
			colorPallet.appendChild(creator.createButton({
				css: btn + " colorBtn",
				id: "write-" + btn,
				onclick: function(e){
					$(".selectedBtn").removeClass("selectedBtn");
					$("#"+e.target.id).toggleClass("selectedBtn");
					parameters.selectedColor =  $("#"+e.target.id).css("color");
					globals.map.removeInteraction(parameters.interaction);
					privateFns.addPointerCircle();
				}
			}));
			
		});
		colorPanel.appendChild(textArea);
		colorPanel.appendChild(colorPallet);
		return colorPanel;
	},
	createTextSizePanel: function(){
		var textSizePanel = creator.createDiv({
		});
		var textArea = creator.createDiv({
			text: "Velg størrelse",
			css: "color-panel"
		});
		var sizePallet = creator.createDiv({
			css: "color-pallet",
		});
		var smallBtn = creator.createInput({
			type: "radio",
			name: "size",
			id: "small-write-btn",
			css: "size-btn-small",
		});
		smallBtn.value = "small-write-text";
		sizePallet.appendChild(smallBtn);
		var smallBtnLabel = creator.createLabel({			
			htmlfor: "small-write-btn",
			text: "Liten",
			css: "size-label-small"
		});
		sizePallet.appendChild(smallBtnLabel);
		
		var medBtn = creator.createInput({
			type: "radio",
			name: "size",
			id: "medium-write-btn",
			css: "size-btn-medium",
		});
		medBtn.value = "medium-write-text";
		medBtn.checked = "checked";
		sizePallet.appendChild(medBtn);
		var medBtnLabel = creator.createLabel({htmlfor: "medium-write-btn", text: "Medium", css: "size-label-medium"});
		sizePallet.appendChild(medBtnLabel);
		
		var largeBtn = creator.createInput({
			type: "radio",
			name: "size",
			id: "large-write-btn",
			css: "size-btn-large",
		})
		largeBtn.value = "large-write-text";
		sizePallet.appendChild(largeBtn);
		var largeBtnLabel = creator.createLabel({htmlfor: "large-write-btn", text: "Stor", css: "size-label-large"});
		sizePallet.appendChild(largeBtnLabel);
		
		textSizePanel.appendChild(textArea);
		textSizePanel.appendChild(sizePallet);
		return textSizePanel;
	},
	writeOnMap: function(btn){
		var panel = $("#map-writer-panel");
		btn.toggleClass("selected");
		if (!btn[0].classList.contains("selected")) {
			privateFns.deactivate(btn);
		} else {
			if(panel[0]){
				panel.show();
			}else{
				privateFns.addWriterControlPanel();
			}
			privateFns.addPointerCircle();
			globals.mapclick = false;
			globals.map.on("click", privateFns.mapWriteClickFunction);
		}
	},
	mapWriteClickFunction: function (evt) {
		if (parameters.btn[0].classList.contains("selected")) {
			var num = globals.numberOfComments + 1;
			var popover = creator.createDiv({id: "popover" + num, css: "popoverClass"});
			document.getElementById("popup").appendChild(popover);
			var popupContent = creator.createDiv({id: "popup-content" + num, css: "popupClass", text: $("#mapWriterField").val()});
			popupContent.style.color = parameters.selectedColor;
			popupContent.style.fontSize = $('input[name="size"]:checked').val() === "large-write-text" ? "25px" : $('input[name="size"]:checked').val() === "medium-write-text" ? "20px" : "15px";
			popupContent.style.fontWeight = $('input[name="size"]:checked').val() === "large-write-text" ? 1000 : 700;
			var popup = new Overlay({
				element: document.getElementById("popover" + num),
				offset: [0, -17],
			});
			popupContent.onclick = function(evt){
				if(remove){						
					evt.target.remove();
				}
			};
			popover.appendChild(popupContent);
			globals.map.addOverlay(popup);
			var element = popup.getElement();
			var coordinate = evt.coordinate;
			popupContent.coordinates = coordinate;
			popup.setPosition(coordinate);
		}
		globals.numberOfComments = num;
	},
	deactivate: function(btn){
		var panel = $("#map-writer-panel");
		globals.map.un("click", privateFns.mapWriteClickFunction);
		var interactions = mapInteractions.getActiveInteractions();
		globals.map.removeInteraction(parameters.interaction);
		panel.hide();
		globals.mapclick = true;
		if (interactions.mapClickInteraction) {
			interactions.mapClickInteraction.setActive(true);
		}
		if(parameters.trashInteraction){
			parameters.trashInteraction.setActive(false);
			remove = false;
			$('#fjernBtn').css("background-color", "white"); 
		}
		interactions.mapHoverInteraction.setActive(true);
		if(btn.removeClass){
			btn.removeClass("selected");
			btn.blur();
		}
	},
	createLinkObject: function(){
		var wktString = "";
		$.each( $("[id*='popup-content']"), function( key, popup ) {
		  var pop = {};
			pop.comment = popup.innerHTML;
			pop.coords = popup.coordinates;
			pop.color = popup.style.color;
			pop.size = popup.style.fontSize;
			pop.weight = popup.style.fontWeight;
			
			if (key > 0) {
				wktString += "|";
			}
			wktString += JSON.stringify(pop);
		});
		if(wktString != ""){
			return wktString;
		}else{
			return "";
		}
	},
	getLinkFromFeatures: function(){			
		if(!document.getElementById("text-share-container")){
			let draw = creator.createDiv({id: "text-share-container"});
			let drawBoks = creator.createInput({type: "checkbox", id: "textCheckBoks"});
			drawBoks.checked = true;
			draw.appendChild(drawBoks);
			let drawBoksLabel = creator.createLabel({text: "Tekst på kart", htmlfor: "drawCheckBoks"});
			draw.appendChild(drawBoksLabel);
			$("#share-controls").append(draw);
			drawBoks.onclick = function (e) {
				let encodedWktString = encodeURIComponent(privateFns.createLinkObject());
				if(e.target.checked && encodedWktString && encodedWktString.length > 0){
					$(".permalink")[0].href = $(".permalink")[0].href + "&text-on-map=" + encodedWktString;
					$(".permalink")[0].innerHTML = $(".permalink")[0].innerHTML + "&text-on-map=" + encodedWktString;
				}else{
					$(".permalink")[0].href = $(".permalink")[0].href.replace("&text-on-map=" + encodedWktString, "");
					$(".permalink")[0].innerHTML = $(".permalink")[0].innerHTML.replace("&amp;text-on-map=" + encodedWktString, "");
				}
			};
		}
		return privateFns.createLinkObject();
	},
	escapeHtml: function (string) {
		var entityMap = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			"'": '&#39;',
			'/': '&#x2F;',
			'`': '&#x60;',
			'=': '&#x3D;'
		};
		return String(string).replace(/[&<>'`=\/]/g, function (s) {
			return entityMap[s];
		});
	},
	linkHandler: function(comments){
		comments.forEach(function(comment){
			privateFns.addCommentToMap(privateFns.escapeHtml(comment));
		});
	},
	addCommentToMap: function(comment){
		comment = JSON.parse(comment);
		var num = globals.numberOfComments +1;
		var popover = creator.createDiv({id: "popover" + num, css: "popoverClass"});
		document.getElementById("popup").appendChild(popover);
		var popupContent = creator.createDiv({id: "popup-content" + num, css: "popupClass"});
		popupContent.style.color = comment.color;
		popupContent.style.fontSize = comment.size;
		popupContent.style.fontWeight = comment.weight;
		popupContent.innerHTML = comment.comment;
		var popup = new Overlay({
			element: document.getElementById("popover" + num),
			offset: [0, -17],
		});
		popover.appendChild(popupContent);
		globals.map.addOverlay(popup);
		var element = popup.getElement();
		var coordinate = comment.coords;
		popupContent.coordinates = coordinate;
		popup.setPosition(coordinate);
		$(element).popover("show");
		globals.numberOfComments = num;
	},
	addPointerCircle: function () {
		var source = new VectorSource();
		var style = new Style({
			image: new Circle({
				radius: 5,
				fill: new Fill({
					color: "rgb(0,0,0,0)",
				})
			})
		});
		var vector = new Vector({
			title: "pointLayer",
			layerId: "pointLayer",
			source: source,
			style: style,
			zIndex: 1000,
		});
		globals.map.addLayer(vector);
		var circleStyle = new Style({
			image: new Circle({
				radius: 5,
				fill: new Fill({
					color: parameters.selectedColor,
				})
			})
		});
		var trashStyle = new Style({
		  image: new Icon({
			anchor: [-0.5, 0.5],
			anchorXUnits: 'fraction',
			anchorYUnits: 'pixels',
			src: 'icons/Soppel.svg',
		  }),
		});
		var draw = new Draw({
			source: source,
			type: "Point",
			style: circleStyle,
			
			interactionId: "textCircle",
		});
		draw.set("itype", "draw");
		parameters.interaction = draw;
		globals.map.addInteraction(draw);
		return source;
	},
	addPointerTrash: function () {
		var source = new VectorSource();
		var trashStyle = new Style({
		  image: new Icon({
			anchor: [-0.5, 0.5],
			anchorXUnits: 'fraction',
			anchorYUnits: 'pixels',
			src: 'icons/Soppel.svg',
		  }),
		});
		var draw = new Draw({
			source: source,
			type: "Point",
			style: trashStyle,
			interactionId: "textTrash",
		});
		draw.set("itype", "draw");
		parameters.trashInteraction = draw;
		globals.map.addInteraction(draw);
		return source;
	},
	clearFunction: function(){
		$(".popoverClass").remove();
		globals.numberOfComments = 0;
	},
	mapWriterClick: function(e){
		var btn = $(e.currentTarget);
		parameters.btn = btn;
		privateFns.writeOnMap(btn);
	},
};

export default {
	clearFunction: privateFns.clearFunction,
	deactivate: privateFns.deactivate,
	getLinkFromFeatures: privateFns.getLinkFromFeatures,
	linkHandler: privateFns.linkHandler, 
	registerPluginFunction: function(registerFunction, callback){
		registerFunction({
			id: "text-on-map",
			deactivate: privateFns.deactivate, 
			clear: [privateFns.clearFunction],
			share: privateFns.getLinkFromFeatures,
			handler: privateFns.linkHandler,
			onclick: privateFns.mapWriterClick,
		}, callback);
	},
};